import { render, staticRenderFns } from "./editor-element.vue?vue&type=template&id=d1d80150&"
import script from "./editor-element.vue?vue&type=script&lang=js&"
export * from "./editor-element.vue?vue&type=script&lang=js&"
import style0 from "./editor-element.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports